import {
  AdityaKanodia,
  KashifJamilAnsari,
  SwaralipiBanerjee,
  Unnamed1,
  Unnamed2,
} from ".";

const testimonials = [
  {
    name: "Dr. Kashif Jamil Ansari",
    business: "The Park Dental Clinic",
    image: KashifJamilAnsari,
    quote:
      "Outstanding legal and investigative prowess. Their results speak in volumes. Highly satisfied with their services.",
  },
  {
    name: "Swaralipi Banerjee (Chief Officer)",
    business: "The Lords and Barons",
    image: SwaralipiBanerjee,
    quote:
      "Innerwork Advisors LLP is a highly professional organization having great expertise in delivering personalized strategical supports in tackling challenging situations.",
  },
  {
    name: "Aditya Kanodia",
    business: "Aditya Realtors Limited",
    image: AdityaKanodia,
    quote:
      "Incredible legal and investigative expertise. Highly recommended for resolving complex cases efficiently.",
  },
  {
    name: "Satish Jaiswal",
    business: null,
    image: Unnamed2,
    quote:
      "All services under one roof, awesome office staff with good humour. Very quick action taken against any case n result proven record, was very satisfied against my complain.",
  },
  {
    name: "Tanusri Chatterjee",
    business: null,
    image: Unnamed1,
    quote:
      "My Daughter In Law works here. Highly professional working environment. Best wishes for Innerwork Advisors LLP.",
  },
  {
    name: "Dr Sriparna Datta",
    business: "London, UK",
    // image: Unnamed1,
    quote:
      "It has been a pleasure to be associated with Innerwork advisors. Your professionalism, kindness and efforts to provide the highest level of customer services beyond comparison. I wish the entire team a successful future ahead.",
  },
  {
    name: "Dr Sonali Guha",
    business: "London, UK",
    // image: Unnamed1,
    quote:
      "Excellent service, professional, friendly and very efficient staff, very reasonable fees,    amazing time management, highly recommended.",
  },
];

export { testimonials };
